/**
 * MUI Menu/Modal defaults to portaling into `document.body`. ModalManager then sets
 * `aria-hidden` on body's *siblings* of that portal — including `#root`, which hides the
 * entire app from assistive tech while a menu is open.
 *
 * Portaling into `#root` keeps the modal container aligned with the React tree so siblings
 * of the portal are layout chrome inside the shell, not `#root` itself.
 *
 * @see https://github.com/mui/material-ui/blob/master/packages/mui-material/src/Modal/ModalManager.js
 */
export function getAppRootModalContainer(): HTMLElement | null {
  if (typeof document === 'undefined') {
    return null;
  }
  return document.getElementById('root');
}
